// The end-user application's entry point.
//
// One of two: `admin/main.js` is the other. Each sits beside its own document, in its own root, because
// each is a Vite build of its own; what they share is under `src/shared/`, and nothing else - which is
// the whole reason there are two, since an end user should never be sent the administrative screens or
// the machinery they are built from.

import '@liasoft/lit-ui/styles.css';
import '../src/styles/app.css';

// Registers all of the kit's custom elements.
import { initTheme } from '@liasoft/lit-ui';

// Error reporting, before anything of ours runs: what the server reports to, the browser reports to.
import { installMonitoring } from '../src/shared/monitoring.js';

void installMonitoring('user');


import '../src/user-root.js';
import { isSignedIn } from '../src/shared/api/session.js';
import { isDeveloperSignedIn } from '../src/user/api/developerSession.js';


// Product information remains readable before JavaScript or sign-in.
const publicPage = location.pathname.replace(/\/$/, '') === '/pricing'
   || (location.pathname === '/' && !isSignedIn() && !isDeveloperSignedIn());

if (publicPage)
{
   initTheme();
}
else
{
   document.querySelector('#public-welcome')?.remove();
   document.querySelector('#app').append(document.createElement('user-root'));
}
